import React from 'react'
import { Button, Col, FormGroup, Row, InputGroup, Form, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import axios, { Promise } from 'axios';
import constants from '../../util/constants';
import HelperBox from './Helperbox/index'
import { hasGrant } from '../../util/grantHelper';
import * as Grants from '../../util/grants';
import './style.scss'
import HelperTable from './HelpTable';
import apiHelper from '../../util/api.helper';
import moment from 'moment';


const { API_BASE_URL } = constants;
const SHEET_FORMATS = [{ name: "Single Grammage", id: 1 }, { name: "All Grammages", id: 2 }, { name: "Single Grammage, Imperial", id: 3 }];



class DataSheets extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            language: {
                chosenLanguage: {label: null, value: null},
                languages: []
            },
            brand: {
                chosenBrand: {label: null, value: null},
                brands: []
            },
            grade: {
                chosenGrade: {label: null, value: null},
                grades: []
            },
            grammage: {
                chosenGrammage: {label: null, value: null},
                rangeGrammage: false,
                minGrammage: null,
                maxGrammage: null,
                grammages: [],
                grammageError: false,
                isThickness: false,
                reportingTypes: []
            },
            mill: {
                chosenMill: {label: null, value: null},
                mills: []
            },
            endUse: {
                chosenEndUse: {label: null, value: null},
                endUses: []
            },
            helpValues: {
                ActiveGrade: null,
                GradeHandling: null,
                MinGrade: null,
                MaxGrade: null
            },
            helpTableData: {
                brandGrades: [],
                electricalData: [],
                labData: []
            },
            isError: false,
            errorMessage: '',
            metric: 'Grammage',
            data: [],
            isLoading: false,
            dropdownStyleMedium: {
                valueContainer: (provided) => ({
                    ...provided,
                    minWidth: '120px'
                }),
                menu: (provided) => ({
                    ...provided,
                    zIndex: 9999
                })
            }
        }
    }

    componentDidMount() {
        this.loadData();
        this.loadLanguages();
        this.loadBrandHelpData();
        this.loadLabHelpData();
    }

    handleAxiosError(action, operation) {
        let message = "Unable to " + action + " data for " + operation + ".";
        this.setState({isError: true, errorMessage: message});
    }


    loadData() {
        let url = API_BASE_URL + 'DataSheet/GetInfoForDataSheets';

        axios.get(url, { headers: this.state.header })
            .then((result) => {
                let availableBrands = result.data.sort((a,b) => a.SortOrder > b.SortOrder ? 1 : -1)
                this.setState({ data: result.data, brand: { chosenBrand: {label: null, value: null}, brands: availableBrands } });
            })
            .catch((error) => {
                console.log(error);
                this.handleAxiosError("get", "sheet information");

            })
    }

    loadLanguages() {
        let url = API_BASE_URL + 'DataSheet/GetLanguages';

        axios.get(url, { headers: this.state.header })
            .then((result) => {
                this.setState({ language: { chosenLanguage: {label: null, value: null}, languages: result.data } })
            })
            .catch((error) => {
                console.log(error);
                this.handleAxiosError("get", "languages");
            })
    }

    loadBrandHelpData() {
        if(hasGrant(Grants.TYPES.TDS_Help_SeeBrandNames))
        {
            let url = API_BASE_URL + 'DataSheet/GetBrandGrades';

            axios.get(url, { headers: this.state.header })
                .then((result) => {
                    let helpDataTemp = this.state.helpTableData;
                    helpDataTemp.brandGrades = result.data;
                    this.setState({ helpTableData: helpDataTemp })
                })
                .catch((error) => {
                    console.log(error);
                    this.handleAxiosError("get", "brand help data");
                })
        }
    }


    loadLabHelpData() {
        if (hasGrant(Grants.TYPES.TDS_Help_Lab)) {
            let url = API_BASE_URL + 'datasheet/getlabdata';

            axios.get(url, {headers: this.state.header})
                .then((result) => {
                    let helpDataTemp = this.state.helpTableData;
                    helpDataTemp.labData = result.data;
                    this.setState({ helpTableData: helpDataTemp })
                })
        }
    }

    downloadFile(id, fileName) {
        let url = 'DataSheet/GetTechnicalDataSheet';
        let requestObject = {
            Language: this.state.language.chosenLanguage.value,
            BrandName: this.state.brand.chosenBrand.value.Id,
            GradeCode: this.state.grade.chosenGrade.value.Id,
            Grammage: this.state.grammage.chosenGrammage.label,
            Mill: this.state.mill.chosenMill.value.Id,
            EndUse: this.state.endUse.chosenEndUse.label === null ? '' : this.state.endUse.chosenEndUse.value.Id,
            ReportId: id,
            FileName: this.getFileName(this.state.grade.chosenGrade.label, this.state.grammage.chosenGrammage.label, this.state.language.chosenLanguage.label, id)
        }
        let result = apiHelper.getFile(this.state.header, url, requestObject, requestObject.FileName)
    }

    getFileName(grade, grammage, language, reportId) {
        let fileLanguage = '';
        let prependedGrammage = '';
        if(reportId !== 2)
        {
            grammage = grammage ?? '';
            prependedGrammage = ('000' + grammage).slice(-3); //Grammage sould always be shown with 3 digits. 
        }

        
        switch(language)
        {
            case 'Svenska':
                fileLanguage = 'se';
                break;

            case 'English':
                fileLanguage = 'eng';
                break;

            case 'Deutsch':
                fileLanguage = 'de';
                break;
        }

        let ending = reportId === 3 ? 'imp' : fileLanguage;
        return grade  + prependedGrammage + '_' + moment().format('YYYYMMDD') + '_' + ending + '.pdf';        
    }

    validateInputs(isAllGrammages) {
        let result = (this.state.language.chosenLanguage.label !== null
            && this.state.brand.chosenBrand.label !== null
            && this.state.grade.chosenGrade.label !== null
            && (isAllGrammages || (this.state.grammage.rangeGrammage ? (this.state.grammage.chosenGrammage.label !== null && this.state.grammage.grammageError === false) : this.state.grammage.chosenGrammage.label !== null))
            && this.state.mill.chosenMill.label !== null
            && (this.state.endUse.endUses.length == 0 || this.state.endUse.chosenEndUse.label !== null)
        );
        return result;
    }


    handleLanguageChange(input) {
        let languageTemp = this.state.language;
        languageTemp.chosenLanguage = {label: input.label, value: input.value};
        this.setState({ language: languageTemp })
    }

    handleBrandChange(input) {
        let brandTemp = this.state.brand;
        let gradeTemp = this.state.grade;
        let endUseTemp = this.state.endUse;
        brandTemp.chosenBrand = {label: input.label, value: input.object};
        gradeTemp.grades = input.object.GradeCodes;
        endUseTemp.endUses = input.object.EndUseTypes ?? [];


        this.setState({ brand: brandTemp, grade: gradeTemp });
        let defaultGrade = this.defaultValue(gradeTemp.grades);
        this.handleGradeChange({ label: defaultGrade == null ? null : defaultGrade?.GradeCode, object: defaultGrade == null ? null :  defaultGrade });
        this.handleEndUseChange({ label: null })
    }

    handleEndUseChange(input) {
        let endUseTemp = this.state.endUse;
        endUseTemp.chosenEndUse = {label: input.label, value: input.value};

        this.setState({ endUse: endUseTemp });
    }

    handleGradeChange(input) {
        let gradeTemp = this.state.grade;
        let grammageTemp = this.state.grammage;
        let millTemp = this.state.mill;
        gradeTemp.chosenGrade = {label: input.label, value: input.object};

        if (input.label != null) {
            let grammage = input.object.GrammageRanges[0];
            grammageTemp.rangeGrammage = grammage.RangeGrammage;
            grammageTemp.reportingTypes = grammage.ReportingTypes;
            grammageTemp.isThickness = grammage.IsThickness;

            if (grammage.RangeGrammage) {
                grammageTemp.grammages = [];
                grammageTemp.minGrammage = grammage.MinGrammage;
                grammageTemp.maxGrammage = grammage.MaxGrammage;
            }
            else {
                grammageTemp.grammages = grammage.Grammages;
                grammageTemp.minGrammage = Math.min(...grammage.Grammages);
                grammageTemp.maxGrammage = Math.max(...grammage.Grammages);
            }


            
            this.setState({ grade: gradeTemp, grammage: grammageTemp, mill: millTemp, metric: this.state.grammage.isThickness ? 'Thickness' : 'Grammage' });
        }
        else {
            grammageTemp.grammages = [];
            grammageTemp.rangeGrammage = false;
            grammageTemp.reportingTypes = [];
            this.setState({ grade: gradeTemp, grammage: grammageTemp });
        }
        millTemp.mills = input?.object?.Mills ?? [];
        this.handleGrammageChange({ label: this.defaultValue(grammageTemp.grammages) }); //, input.object === undefined ? null : input.object.GrammageRanges
        let defaultMill = this.defaultValue(millTemp.mills);
        this.handleMillChange({ label: defaultMill === null ? null: defaultMill.MillName, value: defaultMill === null ? null: defaultMill }); //, input.object === undefined ? null : input.object.MillNames
    }

    defaultValue(array) {
        return array.length === 1 ? array[0] : null;
    }

    toggleGrammageError(toggle) {
        let grammageTemp = this.state.grammage;
        grammageTemp.grammageError = toggle;
        this.setState({ grammage: grammageTemp });
    }

    handleGrammageTextChange(evt) {
        let pattern = /^\d+$/;

        if (evt.target.value.length === 0 || pattern.test(evt.target.value)) {
            this.handleGrammageChange({ label: evt.target.value });
            if (evt.target.value < this.state.grammage.minGrammage || evt.target.value > this.state.grammage.maxGrammage) {
                this.toggleGrammageError(true);
            }
            else
                this.toggleGrammageError(false);
        }
        else {
            this.handleGrammageChange({ label: this.state.grammage.chosenGrammage.label });
        }


    }

    handleGrammageChange(input) {
        let grammageTemp = this.state.grammage;
        grammageTemp.chosenGrammage = {label: input.label, value: input.value};
        grammageTemp.grammageError = false;
        if (input.label === null) {
            grammageTemp.RangeGrammage = false;
        }

        this.setState({ grammage: grammageTemp });

    }

    handleMillChange(input) {
        let millTemp = this.state.mill;
        millTemp.chosenMill = {label: input.label, value: input.value};
        this.setState({ mill: millTemp });
    }



    render() {
        let languageOptions = this.state.language.languages.map((language) => { return { label: language.Language, value: language.LanguageId } });
        let brandOptions = this.state.brand.brands.map((brand) => { return { label: brand.BrandName, value: brand.BrandName, object: brand } });
        let gradeOptions = this.state.grade.grades.map((grade) => { return { label: grade.GradeCode, value: grade.GradeCode, object: grade } });
        let grammageOptions = this.state.grammage.grammages.map((grammage) => { return { label: grammage, value: grammage } });
        let millOptions = this.state.mill.mills.map((mill) => { return { label: mill.MillName, value: mill } });
        let endUseOptions = this.state.endUse.endUses.map((endUse) => { return { label: endUse.EndUseName, value: endUse } });

        return <div>

            <Row>
                <section>
                    <div className="center-block text-center user-heading"> Technical data sheets </div>
                </section>
            </Row>
            <Row>
                <Col>
                    <Button bsStyle="primary" className="report-button" onClick={() => this.props.toggleDataSheetPage(false)}>Return</Button>
                </Col>
            </Row>
            <Row className="margin-top">
                <legend className="mylegend dataLegend">Sheet selection</legend>
            </Row>

            <Row>
                <Col lg={12} fluid="sm">
                    <Form inline>
                        <FormGroup className="select-margin">
                            <InputGroup>
                                <InputGroup.Addon style={{ width: "65px" }}>Language</InputGroup.Addon>
                                <Select searchable={true}
                                    styles={this.state.dropdownStyleMedium}
                                    options={languageOptions}
                                    menuContainerStyle={{ zIndex: 5 }}
                                    value={{ label: this.state.language.chosenLanguage.label }}
                                    onChange={evt => {
                                        this.handleLanguageChange(evt);
                                    }} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup className="select-margin">
                            <InputGroup>
                                <InputGroup.Addon style={{ width: "65px" }}>Brand</InputGroup.Addon>
                                <Select searchable={true}
                                    styles={this.state.dropdownStyleMedium}
                                    options={brandOptions}
                                    menuContainerStyle={{ zIndex: 5 }}
                                    value={{ label: this.state.brand.chosenBrand.label }}
                                    onChange={evt => {
                                        this.handleBrandChange(evt);
                                    }} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup className="select-margin">
                            <InputGroup>
                                <InputGroup.Addon style={{ width: "65px" }}>Grade</InputGroup.Addon>
                                <Select searchable={true}
                                    styles={this.state.dropdownStyleMedium}
                                    options={gradeOptions}
                                    isDisabled={gradeOptions.length <= 0}
                                    menuContainerStyle={{ zIndex: 5 }}
                                    value={{ label: this.state.grade.chosenGrade.label }}
                                    onChange={evt => {
                                        this.handleGradeChange(evt);
                                    }} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup className="select-margin">
                            <InputGroup>
                                <InputGroup.Addon style={{ width: "65px" }}>{this.state.metric}</InputGroup.Addon>
                                {this.state.grammage.rangeGrammage
                                    ? <FormControl className={this.state.grammage.grammageError ? "form-control error" : "form-control"}
                                        onChange={evt => { this.handleGrammageTextChange(evt) }}
                                        value={this.state.grammage.chosenGrammage.label ?? ''} />
                                    : <Select searchable={true}
                                        styles={this.state.dropdownStyleMedium}
                                        options={grammageOptions}
                                        isDisabled={grammageOptions.length <= 0}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        value={{ label: this.state.grammage.chosenGrammage.label }}
                                        onChange={evt => {
                                            this.handleGrammageChange(evt);
                                        }} />
                                }

                            </InputGroup>
                        </FormGroup>
                        <FormGroup className="select-margin">
                            <InputGroup>
                                <InputGroup.Addon style={{ width: "65px" }}>Mill</InputGroup.Addon>
                                <Select searchable={true}
                                    styles={this.state.dropdownStyleMedium}
                                    options={millOptions}
                                    isDisabled={millOptions.length <= 0}
                                    menuContainerStyle={{ zIndex: 5 }}
                                    value={{ label: this.state.mill.chosenMill.label }}
                                    onChange={evt => {
                                        this.handleMillChange(evt);
                                    }} />
                            </InputGroup>
                        </FormGroup>
                        {endUseOptions.length > 0
                            ? <FormGroup className="select-margin">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>End use</InputGroup.Addon>
                                    <Select searchable={true}
                                        styles={this.state.dropdownStyleMedium}
                                        options={endUseOptions}
                                        isDisabled={endUseOptions.length <= 0}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        value={{ label: this.state.endUse.chosenEndUse.label }}
                                        onChange={evt => {
                                            this.handleEndUseChange(evt);
                                        }} />
                                </InputGroup>
                            </FormGroup>
                            : null
                        }

                    </Form>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Row lg={12}>
                        <Col className="margin-top-20">
                            <HelperBox activeGrade={this.state.grammage.chosenGrammage.label} gradeHandling={this.state.metric} minGrammage={this.state.grammage.minGrammage} maxGrammage={this.state.grammage.maxGrammage} />  
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <b>{this.state.errorMessage}</b>
                        </Col>
                    </Row>
                    <Row>
                    <Col>
                        {
                            SHEET_FORMATS.map((dataSheet) => {
                                return <Button
                                    className="report-button"
                                    key={dataSheet.id}
                                    bsStyle="primary"
                                    disabled={this.state.grammage.reportingTypes && this.state.grammage.reportingTypes.find(x => x.DataSheetId === dataSheet.id) === undefined || !this.validateInputs(dataSheet.id === 2)}
                                    onClick={((evt) => { this.downloadFile(dataSheet.id, dataSheet.name) })}>
                                    {dataSheet.name}
                                </Button>
                            }
                            )
                        }
                    </Col>
                    </Row>
                </Col>
            </Row>
            {(hasGrant(Grants.TYPES.TDS_Help_SeeBrandNames) || hasGrant(Grants.TYPES.TDS_Help_SeeEl))
                ?
                <Col xs={12}>
                    <Row className="margin-top">
                        <section>
                            <div className="center-block text-center user-heading"> Help </div>
                        </section>
                    </Row>
                    <Row fluid="sm" className="margin-top">
                        {
                            hasGrant(Grants.TYPES.TDS_Help_SeeBrandNames)
                                ? <Col xs={4} lg={2}>
                                    <HelperTable data={this.state.helpTableData.brandGrades} columns={this.getBrandColumns()} />
                                </Col>
                                : null
                        }
                        {
                            hasGrant(Grants.TYPES.TDS_Help_Lab)
                                ? <Col xs={8} lg={6}>
                                    <HelperTable data={this.state.helpTableData.labData} columns={this.getLabColumns()} />
                                </Col>
                                : null
                        }

                    </Row>
                </Col>
                : null
            }
        </div>
    }


    getBrandColumns() {
        return [
            {
                Header: "Brand names",
                columns: [
                    {
                        Header: "Brand name",
                        accessor: "BrandName"
                    },
                    {
                        Header: "Sort code",
                        accessor: "GradeCode"
                    }
                ]
            }

        ]
    }

    getLabColumns() {
        return [
            {
                Header: "Lab information",
                columns: [
                    {
                        Header: "PM",
                        accessor: "PM",
                        width: 100
                    },
                    {
                        Header: "Sort letter",
                        accessor: "SortLetter",
                        width: 100
                    },
                    {
                        Header: "Sort number",
                        accessor: "SortNumber",
                        width: 100
                    },
                    {
                        Header: "Brand name",
                        accessor: "BrandName"
                    }
                ]
            }
        ]
    }


}

export default DataSheets;